import GuestInterviewsScene from '../../scenes/MarketingPages/scenes/GuestInterviews';

export default GuestInterviewsScene;
